'use client'

import Script from 'next/script'

export function ConciergeLoader({
  position,
}: {
  position?: string
}) {
  const config = {
    apiUrl: '/api/concierge',
    position: position || 'bottom-right',
  }

  return (
    <>
      <Script
        id="concierge-config"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: `window.ConciergeConfig=${JSON.stringify(config)};`,
        }}
      />
      <Script
        id="concierge-widget"
        src="/api/concierge/widget.js"
        strategy="afterInteractive"
      />
    </>
  )
}
